<template>
  <!-- Default slot content -->
  <slot v-if="status === 'loading' || status === 'success'" />
  <!-- Render fallback screen  content -->

  <service-unavailable v-else-if="status === 'error'" />
  <response-empty v-if="status === 'data_empty'" />
</template>

<script setup>
import { inject } from 'vue'
import ServiceUnavailable from './ServiceUnavailable.vue'
import ResponseEmpty from './ResponseEmpty.vue'
const status = inject('status')
</script>
